import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col } from "reactstrap";
//Redux
import { useDispatch, useSelector } from 'react-redux'
import { SEARCH_VALUES, SEARCH_BY_STORE } from '../../store/search/actionsTypes'
import { ProductService } from '../../services/productService';
import ProductList from '../products/ProductList';
import ProductFilters from '../products/ProductFilters';
import { FILTERS_POSITION_BOTTOM } from 'react-bootstrap-table-next';
import { ApiConstants } from '../../common/apiConstants';
import Loading from '../products/Loading';
import Spinner from 'reactstrap/lib/Spinner';


export default function StoreProducts() {
    const params = useParams();
    const searchParams = useSelector(state => state.Search);
    const user = useSelector(x => x.Login.user);
    const [products, setProducts] = useState([]);
    const [shownProducts, setShownProducts] = useState([]);
    const [localFilters, setLocalFilters] = useState({ sort: ApiConstants.SORT.DEFAULT, min: null, max: null })
    const productService = new ProductService();
    const defaultFilters = { ...localFilters, keyWord: "", opciones: [], categorias: [] }
    const [loading, setLoading] = useState(false);
    const [size, setSize] = useState(12);
    //const keyWord = useSelector(state => state.Search.keyWord)
    const scrollRef = useRef();

    useEffect(() => {
        const handleScroll = () => {
            const element = scrollRef.current;
            if (!element) return;

            const nearBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - 10;
            if (nearBottom) {
                setSize(prevSize => prevSize + 12); // Cargar más productos
            }
        };

        const container = scrollRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);

    

    const getProductsByStore = async (filter) => {
        let products = await productService.getProductsByStore(null, 1, size);
        if (filter) {
            if (filter.discount) {
                products = products.filter(x => x.productDetailModel.descuento == filter.discount)
            }
        }
        setProducts(products ?? []);
    }

    const newFilters = async (newFiltersInput) => {
        setLoading(true);
        setProducts([]);
    
        const filtrosLimpios = {
            sort: "DEFAULT",
            min: null,
            max: null,
            keyWord: "",
            IdTienda: parseInt(params.id), // este debe ser fijo
            característica: ""
        };
    
        const newFilters = {
            ...filtrosLimpios,
            ...newFiltersInput,
            keyWord: newFiltersInput?.nombreProducto || searchParams?.keyWord || "",
        };
    
        let productosTotales = [];
    
        const palabrasClave = (newFilters.keyWord || "").split(/[, ]+/).filter(Boolean);
    
        if (palabrasClave.length > 0) {
            for (const palabra of palabrasClave) {
                const filtrosPorPalabra = {
                    ...newFilters,
                    keyWord: palabra
                };
    
                const productos = await productService.GetBySpecificFilters(filtrosPorPalabra, 1, size);
                if (productos?.length) {
                    productosTotales = [...productosTotales, ...productos];
                }
            }
    
            productosTotales = productosTotales.reduce((acc, item) => {
                if (!acc.some(prod => prod.id === item.id)) acc.push(item);
                return acc;
            }, []);
        } else {
            productosTotales = await productService.GetBySpecificFilters(newFilters, 1, size);
        }
    
        setProducts(productosTotales ?? []);
        setLocalFilters(newFilters);
        setLoading(false);
    };
    
    

    // const newFilters = async (newFilters) => {
    //     setLoading(true);
    //     setProducts([]);
    
    //     // Preparar los filtros base
    //     newFilters = {
    //         ...newFilters,
    //         keyWord: newFilters.nombreProducto || searchParams.keyWord || "",
    //         IdTienda: parseInt(params.id),
    //         característica: "",
    //         min: newFilters.min ? parseInt(newFilters.min) : null,
    //         max: newFilters.max ? parseInt(newFilters.max) : null,
    //         sort: newFilters.sort
    //     };
    
    //     let productosTotales = [];
    
    //     if (newFilters.nombreProducto) {
    //         // Buscar el producto por nombre usando el nuevo endpoint
    //         const producto = await productService.getProductByName(newFilters.nombreProducto);
            
    //         // Si se encuentra, aplicar filtros manuales
    //         if (producto) {
    //             const cumpleMin = newFilters.min == null || producto.precio >= newFilters.min;
    //             const cumpleMax = newFilters.max == null || producto.precio <= newFilters.max;
    //             const mismaTienda = producto.idTienda === newFilters.IdTienda;
    
    //             if (cumpleMin && cumpleMax && mismaTienda) {
    //                 productosTotales = [producto];
    //             }
    //         }
    //     } else {
    //         // Si no hay nombreProducto, usar los filtros generales
    //         productosTotales = await productService.GetBySpecificFilters(newFilters, 1, size);
    //     }
    
    //     setProducts(productosTotales ?? []);
    //     setLocalFilters(newFilters);
    //     setLoading(false);
    // };

    // useEffect(() => {
    //     getProductsByStore();
    // }, [])

    useEffect(() => {
        setLoading(true);
        //getProductsByStore();

        localFilters && newFilters(localFilters)
    }, [size])

    useEffect(() => {
        console.log(searchParams)
        if (searchParams.keyWord) { newFilters({ ...defaultFilters, keyWord: searchParams.keyWord }) };
    }, [searchParams])

    useEffect(() => {
        let productsTmp = products.map(x => {
            return {
                ...x,
                productDetailModel: {
                    ...x.productDetailModel,
                    valor: user && user.autorizadoClienteCorp ? (x.productDetailModel.valorCorp | 0) : x.productDetailModel.valor
                }
            }
        })

        switch (localFilters.sort) {
            case ApiConstants.SORT.ASC:
                productsTmp = productsTmp.sort((a, b) => a.productDetailModel.valor - b.productDetailModel.valor)
                break;
            case ApiConstants.SORT.DESC:
                productsTmp = productsTmp.sort((a, b) => b.productDetailModel.valor - a.productDetailModel.valor)
                break;
            default:
                productsTmp = productsTmp.sort((a, b) => a.productDetailModel.id - b.productDetailModel.id)
                break
        }

        if (localFilters.min)
            productsTmp = productsTmp.filter(x => x.productDetailModel.valor >= Number.parseInt(localFilters.min))

        if (localFilters.max)
            productsTmp = productsTmp.filter(x => x.productDetailModel.valor <= Number.parseInt(localFilters.max))

        setShownProducts(productsTmp)
        
    }, [products])

        return (
        <React.Fragment>
            <div className="page-content">
                <Row style={{ marginTop: "10px" }}>
                    <Col lg="3">
                        <span>{loading}</span>
                        <ProductFilters sendFilters={newFilters} params={{
                            searchType: SEARCH_BY_STORE,
                            searchValue: params.id
                        }} />
                    </Col>
                    <Col md="8">
                        {loading ? (
                            <div style={{
                                display: "flex",
                                width: "100%",
                                left: 0,
                                height: "75vh",
                                position: "fixed",
                                alignContent: "center",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <Spinner color="dark" />
                            </div>
                        ) : (
                            <div
                                ref={scrollRef}
                                style={{
                                    maxHeight: "80vh",
                                    overflowY: "scroll",
                                    paddingRight: "10px",
                                    scrollbarWidth: "none",
                                    msOverflowStyle: "none"
                                }}
                                className="custom-scroll-container"
                            >
                                <style>
                                    {`
                                        .custom-scroll-container::-webkit-scrollbar {
                                            display: none;
                                        }
                                    `}
                                </style>

                                <ProductList products={shownProducts || []} />
                                {/* Ya no se necesita el botón */}
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
}